import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import utils from "../utils";
import {LANGUAGES} from "../assets/constants";
import Loader from "../components/Loader";

const normalizeLang = (value) => {
    const lang = (value || "").toLowerCase().split("-")[0];
    return LANGUAGES.includes(lang) ? lang : "sp";
};

const hasLikelyInvalidLangPrefix = (segment = "") =>
    segment.includes("-") || /^[a-z]{2}_[a-z]{2}$/i.test(segment);

export default function useLocationNavigation() {
    const navigate = useNavigate();
    const {pathname, state} = useLocation();
    const {language} = useSelector(store => store.language)
    const [loader, setLoader] = useState(true);
    const safeLanguage = normalizeLang(language);
    
  useEffect(() => { 
        if (pathname === "/") {
            setLoader(false);
            navigate(`/${safeLanguage}`, {state, replace: true})
        } else {
            /*if the pathname does not contain language id*/
            if (!utils.hasLanguageInPathname(pathname, LANGUAGES)) {
                setLoader(false);
                if (hasLikelyInvalidLangPrefix(pathname.split("/")[1])) {
                    const strippedPath = pathname.replace(/^\/[^/]+/, "") || "/";
                    navigate(`/${safeLanguage}${strippedPath}`, {state, replace: true});
                } else {
                    navigate(`/${safeLanguage}${pathname}`, {state, replace: true});
                }
            }
        }
    }, [pathname, safeLanguage]);

    return loader
}
